import { registerPlugin } from '@capacitor/core';
const Badge = registerPlugin('Badge', {
    web: () => import('./web').then(m => new m.BadgeWeb()),
});
export * from './definitions';
export { Badge };
//# sourceMappingURL=index.js.map